import { render, staticRenderFns } from "./peopleSampleDesc.vue?vue&type=template&id=1cb3783e&scoped=true"
import script from "./peopleSampleDesc.vue?vue&type=script&lang=js"
export * from "./peopleSampleDesc.vue?vue&type=script&lang=js"
import style0 from "./peopleSampleDesc.vue?vue&type=style&index=0&id=1cb3783e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3783e",
  null
  
)

export default component.exports